var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "门店名称", prop: "name" } },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "name", $$v)
                            },
                            expression: "queryParams.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "门店类型", prop: "typeCode" } },
                      [
                        _c("BjSelectLov", {
                          attrs: { "lov-code": "SCHL.SHOP_TYPE" },
                          model: {
                            value: _vm.queryParams.typeCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "typeCode", $$v)
                            },
                            expression: "queryParams.typeCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "渠道仓状态", prop: "status" } },
                      [
                        _c("BjSelectLov", {
                          attrs: { "option-list": _vm.STATUS_ENABLED_TRUE },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "负责人", prop: "manager" } },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.manager,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "manager", $$v)
                            },
                            expression: "queryParams.manager",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "所属公司", prop: "orgName" } },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.orgName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "orgName", $$v)
                            },
                            expression: "queryParams.orgName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { prop: "selfPickupFlag" },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _vm._v(" 是否自提 "),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      placement: "top-start",
                                      content: "是否为O2O订单的自提门店",
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-question" })]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: { "option-list": _vm.STATUS_YES_TRUE },
                          model: {
                            value: _vm.queryParams.selfPickupFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "selfPickupFlag", $$v)
                            },
                            expression: "queryParams.selfPickupFlag",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function (tableOperationProp) {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:BusinessChannelPhysicalList_Delete",
                            arg: "BusinessChannelPhysicalList_Delete",
                          },
                        ],
                        staticClass: "delete-btn",
                        attrs: {
                          type: "primary",
                          disabled: tableOperationProp.notSelected,
                        },
                        on: { click: _vm.onDeleteSelected },
                      },
                      [_vm._v(_vm._s(_vm.$t("delText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:BusinessChannelPhysicalList_Add",
                            arg: "BusinessChannelPhysicalList_Add",
                          },
                        ],
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onAdd },
                      },
                      [_vm._v("新增门店")]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "status"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: scope.row.status
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_ENABLED_TRUE.bjGet(
                                                    scope.row.status
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : col.prop === "selfPickupFlag"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: scope.row.selfPickupFlag
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_YES_TRUE.bjGet(
                                                    !!scope.row.selfPickupFlag
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : col.prop === "channelWarehouseStatus"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: scope.row
                                                .channelWarehouseStatus
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_ENABLED_TRUE.bjGet(
                                                    scope.row
                                                      .channelWarehouseStatus
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:BusinessChannelPhysicalList_Edit",
                                            arg: "BusinessChannelPhysicalList_Edit",
                                          },
                                        ],
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                    props.row.channelWarehouseStatus
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName:
                                                  "v-permission:BusinessChannelPhysicalList_Status",
                                                arg: "BusinessChannelPhysicalList_Status",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onStatus(
                                                  false,
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("disableText"))
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    !props.row.channelWarehouseStatus
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName:
                                                  "v-permission:BusinessChannelPhysicalList_Status",
                                                arg: "BusinessChannelPhysicalList_Status",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onStatus(
                                                  true,
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("enableText")))]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:BusinessChannelPhysicalList_Delete",
                                            arg: "BusinessChannelPhysicalList_Delete",
                                          },
                                        ],
                                        staticClass: "delete-btn",
                                        attrs: {
                                          disabled:
                                            props.row.channelWarehouseStatus,
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDelete(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("delText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("DataForm", {
        ref: "DataForm",
        on: { reFresh: _vm.reFresh, batchDeleteApi: _vm.batchDeleteApi },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }